export const CREATE_NEW_EVENT = 'CREATE NEW EVENT'
export const VIEW_VIRTUAL_POWER_PLANTS = 'VIEW VIRTUAL POWER PLANTS'
export const PROGRAM_SETTINGS = 'PROGRAM SETTINGS'
export const SYSTEMS_ENROLLMENT = 'SYSTEMS ENROLLMENT'
export const SYSTEMS_ADDITION = 'SYSTEMS ADDITION'
export const SYSTEMS_APPROVAL = 'SYSTEMS APPROVAL'
export const AUTO_ENROLLMENT = 'AUTO ENROLLMENT'
export const ENROLL_NEW_SYSTEM = 'ENROLL NEW SYSTEM'
export const PROGRAM_STATUS_INACTIVE_COLOR = '#FFD800'

export const PROGRAM_STATUS_ACTIVE_COLOR = '#7ACF38'
